import * as React from 'react'
import styled, { AnyStyledComponent } from 'styled-components'
import I18n from '../../../../../core/i18n'
import { IWindow } from '../../../../../core/interfaces'
import { reservationService } from '../../../../../core/services'
import { Button, InputText, Select, Spacer } from '../../../../atoms'
import { Form } from '../../../../molecules'

declare var window: IWindow

interface IDelivery {
  status: string
}
interface IProps {
  reservationId: number
  deliveryStatus: string
  isAdmin: boolean
  setDeliveryStatus(IDelivery): void
}

const StatusModal: React.FC<IProps> = props => {
  const [modalErrors, setModalErrors] = React.useState<{ [key: string]: null | string }>({
    reason: null,
  })
  const [isSubmittable, setIsSubmittable] = React.useState<boolean>(false)
  const [isProcessing, setIsProcessing] = React.useState(false)
  const [isShowTaxiNo, setIsShowTaxiNo] = React.useState<boolean>(false)
  const [taxiNo, setTaxiNo] = React.useState<string>('')
  const AdminOptions = [
    { label: 'ステータスを選択してください', value: '' },
    { label: '配車完了', value: 'dispatched' },
    { label: '店舗到着', value: 'taxi_arrived' },
    { label: 'タクシーへの商品受け渡し完了', value: 'received' },
    { label: '調理完了', value: 'cooked' },
    { label: '配送先到着 / 商品提供完了', value: 'completed' },
  ]
  const HostOptions = [
    { label: 'ステータスを選択してください', value: '' },
    { label: 'タクシーへの商品受け渡し完了', value: 'received' },
    { label: '調理完了', value: 'cooked' },
    { label: '商品提供完了', value: 'completed' },
  ]
  const deliveryOptions = props.isAdmin ? AdminOptions : HostOptions
  const onChangeHandle = e => {
    const value = e.target.value
    const status = props.deliveryStatus
    let result = false
    if (status === 'requested') {
      if (value === 'dispatched') {
        result = true
      }
    } else if (status === 'dispatched') {
      if (value === 'taxi_arrived') {
        result = true
      }
    } else if (status === 'taxi_arrived') {
      if (value === 'received') {
        result = true
      }
    } else if (status === 'received') {
      if (value === 'completed') {
        result = true
      }
    } else if (status === 'received') {
      if (value === 'completed') {
        result = true
      }
    } else if (status === 'shop_approved') {
      if (value === 'cooked') {
        result = true
      }
    } else if (status === 'cooked') {
      if (value === 'completed') {
        result = true
      }
    } else {
      result = false
    }
    setIsSubmittable(result)

    if (value === 'dispatched') {
      setIsShowTaxiNo(true)
    } else {
      setIsShowTaxiNo(false)
    }
  }

  const handleSubmit = async (initialValues, values) => {
    setIsProcessing(true)
    let params = {}
    if (isShowTaxiNo) {
      params = {
        delivery: {
          status: values.status,
        },
        reservation: {
          taxi_no: taxiNo,
        },
      }
    } else {
      params = {
        delivery: {
          status: values.status,
        },
      }
    }

    const { flush, reservation } = await reservationService.updateDelivery(
      props.reservationId,
      params
    )
    props.setDeliveryStatus(reservation.delivery)
    window.globalModal.closeModal()
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
  }

  return (
    <Form
      fields={{ status: 'status', taxi_no: 'taxi_no' }}
      handleUpdateForm={updatedErrors => {
        setModalErrors(updatedErrors)
      }}
      handleSubmit={handleSubmit}
    >
      <Select
        required={true}
        name="status"
        options={deliveryOptions}
        label={I18n.t('generic.status')}
        defaultValue="requested"
        onChangeHandler={onChangeHandle}
      />
      {isShowTaxiNo && (
        <>
          <Spacer />
          <InputText
            required={true}
            name="phone"
            defaultValue={''}
            label={'タクシーNo.'}
            onChangeHandler={e => setTaxiNo(e.target.value)}
          />
        </>
      )}
      <S.Footer>
        <Button
          primary={true}
          disabled={isProcessing || !isSubmittable || (isShowTaxiNo && !taxiNo)}
        >
          {I18n.t('generic.update')}
        </Button>
      </S.Footer>
    </Form>
  )
}
const S: { [key: string]: AnyStyledComponent } = {}

S.Footer = styled.div`
  text-align: center;
  margin-top: 20px;
`
export default StatusModal
